import { Line } from '@react-three/drei';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { PRIMARY_COLOR_ACCENT_HEX } from 'shared/constants';

export const SnapEdgeMarker = () => {
    const snapEdgeMarker = usePlacementStore(useShallow((state) => state.snapEdgeMarker));
    if (!snapEdgeMarker) {
        return null;
    }

    return (
        <Line
            color={PRIMARY_COLOR_ACCENT_HEX}
            dashed={false}
            depthTest={false}
            lineWidth={4}
            points={[snapEdgeMarker.start, snapEdgeMarker.end]}
        />
    );
};
